import { useEffect, useRef } from 'react';

const DetectSwipe = (divID: string, onSwipeUp: () => void, onSwipeDown: () => void, minSwipeDistance: number = 10) => {

  const touchStart = useRef<{x: number; y: number } | null>(null); //se usa Ref en vez una variable normal para que no se sobreescriba con cada redraw

  useEffect(() => {
    const handleTouchStart = (event: TouchEvent) => {
      const touch = event.touches[0];
      touchStart.current = { x: touch.clientX, y: touch.clientY };
    };

    const handleTouchEnd = (event: TouchEvent) => {
      if (!touchStart.current) return;
    
        const touch = event.changedTouches[0];
        const diffX = touchStart.current.x - touch.clientX;
        const diffY = touchStart.current.y - touch.clientY;
        touchStart.current = null;
        
        if(Math.abs(diffX) + Math.abs(diffY) < minSwipeDistance) return; //didn't move enough

        if (Math.abs(diffX) < Math.abs(diffY)) {// Movement was more vertical than horizontal
          if (diffY > 0) {
            onSwipeUp();
          } else {
            onSwipeDown();
          }
        }
    };

    const div = document.getElementById(divID);
    if (div) {
      div.addEventListener('touchstart', handleTouchStart);
      div.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      if (div) {
        div.removeEventListener('touchstart', handleTouchStart);
        div.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, [divID, onSwipeUp, onSwipeDown, minSwipeDistance]);
};

export default DetectSwipe;
